// Global error handler for catching asynchronous errors
export const setupGlobalErrorHandlers = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    
    // Check if it's the specific message channel error
    if (event.reason && event.reason.message && 
        event.reason.message.includes('message channel closed')) {
      console.warn('Message channel error detected - this is likely from a browser extension');
      event.preventDefault(); // Prevent the error from being logged
      return;
    }
    
    // For other errors, you might want to log them or show a user-friendly message
    if (process.env.NODE_ENV === 'development') {
      console.error('Unhandled promise rejection details:', {
        reason: event.reason,
        stack: event.reason?.stack
      });
    }
  });

  // Handle global errors
  window.addEventListener('error', (event) => {
    console.error('Global error:', event.error);
    
    // Check if it's the specific message channel error
    if (event.error && event.error.message && 
        event.error.message.includes('message channel closed')) {
      console.warn('Message channel error detected - this is likely from a browser extension');
      event.preventDefault(); // Prevent the error from being logged
      return;
    }
  });

  // Handle async errors in React
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Filter out the specific message channel error
    const message = args.join(' ');
    if (message.includes('message channel closed')) {
      console.warn('Message channel error filtered out - likely from browser extension');
      return;
    }
    
    // Filter out infinite loop errors
    if (message.includes('Maximum update depth exceeded')) {
      console.warn('Infinite loop error detected - this should be fixed now');
      return;
    }
    
    // Log other errors normally
    originalConsoleError.apply(console, args);
  };
};

// Utility function to safely execute async operations
export const safeAsync = async (asyncFunction, fallbackValue = null) => {
  try {
    return await asyncFunction();
  } catch (error) {
    console.error('Safe async operation failed:', error);
    return fallbackValue;
  }
};

// Utility function to wrap Firebase operations
export const safeFirebaseOperation = async (operation, fallbackValue = null) => {
  try {
    return await operation();
  } catch (error) {
    // Check if it's the message channel error
    if (error.message && error.message.includes('message channel closed')) {
      console.warn('Firebase operation failed due to message channel error - likely browser extension interference');
      return fallbackValue;
    }
    
    console.error('Firebase operation failed:', error);
    return fallbackValue;
  }
};
